import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/LayoutIndex.vue";
import LayoutAiChat from "@/layout/LayoutIndexAiChat.vue";
import store from "../store";
// import store from '@/store'

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/LoginIndex"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/",
        name: "dashboard",
        component: () => import("@/views/dashboard/dashBoard"),
        meta: { title: "首页" },
      },
    ],
  },
  {
    path: "",
    component: LayoutAiChat,
    children: [
      {
        path: "/aichat",
        component: () => import("@/views_aichat/dashboard/dashBoard.vue"),
        name: "aichat_dashboard",
        meta: {
          title: "AI对话管理端欢迎页",
        },
      },
      {
        path: "/aichat/ana",
        name: "aichat_ana",
        component: () => import("@/views_aichat/revenue/analysisAnalyze"),
        meta: { title: "数据分析" },
      },
      {
        path: "/aichat/user_list",
        component: () => import("@/views_aichat/user/UserList.vue"),
        name: "aichat_user_list",
        meta: {
          title: "用户列表",
        },
      },
      {
        path: "/aichat/chat",
        component: () => import("@/views_aichat/user/ChatPage.vue"),
        name: "aichat_chat",
        meta: {
          title: "聊天列表",
        },
      },
{
        path: "/aichat/common_problem",
        component: () => import("@/views_aichat/function/commonProblem.vue"),
        name: "aichat_commonProblem",
        meta: {
          title: "常见问题",
        },
      },
      {
        path: "/aichat/page_pay_way",
        component: () => import("@/views_aichat/function/pagePayWay.vue"),
        name: "aichat_page_pay_way",
        meta: {
          title: "付款方式管理",
        },
      },
{
        path: "/aichat/openai_account",
        component: () => import("@/views_aichat/function/AccountList"),
        name: "aichat_openai_account",
        meta: {
          title: "openai账号列表",
        },
      },
      {
        path: "/aichat/projectAdmin",
        component: () => import("@/views_aichat/function/projectAdmin"),
        name: "aichat_projectAdmin",
        meta: {
          title: "项目配置",
        },
      },
      {
        path: "/aichat/daily_data",
        component: () => import("@/views_aichat/revenue/DailyData.vue"),
        name: "aichat_daily_data",
        meta: {
          title: "收支情况",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/iframe",
        component: () => import("@/views/iframe/iframe.vue"),
        name: "iframe",
        meta: {
          title: "iframe页面",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/order_list",
        component: () => import("@/views/order/OrderList.vue"),
        name: "order_list",
        meta: {
          title: "订单列表",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/chat_rule",
        component: () => import("@/views/kefu/ChatRule.vue"),
        name: "chat_rule",
        meta: {
          title: "智能客服知识库",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/income_relationship",
        component: () => import("@/views/revenue/IncomeRelationship.vue"),
        name: "income_relationship",
        meta: {
          title: "推广关系管理",
        },
      },
    ],
  },
  {
    path: "/ghz_cs",
    component: () => import("@/views/cs/cs.vue"),
    name: "cs",
    meta: {
      title: "公众号测试",
    },
  },
  {
    path: "/setting",
    component: Layout,
    children: [
      {
        path: "/cicd_file",
        component: () => import("@/views/system/cicdfile.vue"),
        name: "cicd_file",
        meta: {
          title: "cicd文件管理",
        },
      },
      {
        path: "/adminsetting2",
        component: () => import("@/views/system/adminsetting2.vue"),
        name: "adminsetting2",
        meta: {
          title: "共用配置管理",
        },
      },
      {
        path: "/ShortLink",
        component: () => import("@/views/system/ShortLink.vue"),
        name: "ShortLink",
        meta: {
          title: "短链接配置",
        },
      },
      {
        path: "/FileManage",
        component: () => import("@/views/system/FileManage.vue"),
        name: "FileManage",
        meta: {
          title: "文件管理",
        },
      },
      {
        path: "/SimpleSetting",
        component: () => import("@/views/system/SimpleSetting.vue"),
        name: "SimpleSetting",
        meta: {
          title: "快捷配置",
        },
      },
      {
        path: "/HarmonyTaskCenter",
        component: () => import("@/views/system/HarmonyTaskCenter.vue"),
        name: "HarmonyTaskCenter",
        meta: {
          title: "鸿蒙应用体验中心",
        },
      },
      {
        path: "/HarmonyUserManage",
        component: () => import("@/views/system/HarmonyUserManage.vue"),
        name: "HarmonyUserManage",
        meta: {
          title: "鸿蒙用户管理",
        },
      },
      {
        path: "/AppAssignAnalysis",
        component: () => import("@/views/system/AppAssignAnalysis.vue"),
        name: "AppAssignAnalysis",
        meta: {
          title: "应用分配分析",
        },
      },
      {
        path: "/DatePhaseQuery",
        component: () => import("@/views/system/DatePhaseQuery.vue"),
        name: "DatePhaseQuery",
        meta: {
          title: "过期日期查询",
        },
      },
      {
        path: "/RewardReview",
        component: () => import("@/views/system/RewardReview.vue"),
        name: "RewardReview",
        meta: {
          title: "奖励审核",
        },
      },
      {
        path: "/QiyeweixinFeedback",
        component: () => import("@/views/system/QiyeweixinFeedback.vue"),
        name: "QiyeweixinFeedback",
        meta: {
          title: "企微投诉管理",
        },
      },
      {
        path: "/WithdrawRecord",
        component: () => import("@/views/system/WithdrawRecord.vue"),
        name: "WithdrawRecord",
        meta: {
          title: "红包领取记录",
        },
      },
      {
        path: "/ErrorCodeView",
        component: () => import("@/views/system/ErrorCodeView.vue"),
        name: "ErrorCodeView",
        meta: {
          title: "错误代码查看",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (store.state.token === "not login" && to.path !== "/login") {
    next({ path: "/login" });
  }
  if (to.params.title) {
    store.commit("setTitle", to.params.title);
  }
  document.title = `${to.meta.title}`;
  next();
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
